module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "userQuestions"
    }
  }, [(_vm.showPrivacyQuestions || _vm.isAdmin) ? _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('message.discussionTabMyQuestions')))]), _vm._v(" "), _c('user-profile-questions', {
    attrs: {
      "userId": _vm.userId,
      "type": "MY_QUESTIONS"
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('message.discussionTabMyAnswers')))]), _vm._v(" "), _c('user-profile-questions', {
    attrs: {
      "userId": _vm.userId,
      "type": "MY_ANSWERS"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showPrivacyQuestions && !_vm.isAdmin) ? _c('p', [_vm._v(_vm._s(_vm.$t('message.labelDiscussionPrivate')))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b7b7a73","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile/ProfileDiscussion.vue
// module id = 3714
// module chunks = 1